<template>
  <div class='operationlog'>
    <!-- 筛选 -->
    <!-- <h3 class="flex-row-start" style="margin-top: 0">条件筛选</h3> -->
    <el-form @submit.native.prevent label-width='80px'>
      <el-row>
        <el-col :span="8">
          <el-form-item label='日期:'>
            <el-date-picker
              size="small"
              v-model="f_daterange"
              type="daterange"
              align="right"
              unlink-panels
              range-separator=" ~ "
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy-MM-dd"
              @change='currentPage = 1; getOperationlog()'
              :editable='false'
              :clearable='false'
              style="margin-left: 10px"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span='6' :offset='2'>
          <el-form-item label='操作人:'>
            <el-select style="margin-left: 10px" size='small' v-model="create_user_id" @change="currentPage= 1; getOperationlog()">
              <el-option label='全部用户' value='all'></el-option>
              <el-option v-for="(item, index) in userlist" :key="index" :label='item.name' :value='item.id'></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    

    <!-- 盒子列表 -->
    <div class="flex-row-between">
      <h3 width='100px'>操作日志</h3>
      <div>当前 {{total > 0 ? (pageStart + 1) : 0}} - {{pageEnd > total ? total : pageEnd}} 项, 共 {{total}} 项</div>
    </div>
    <el-table
      :data='operationlog'
      stripe
      style='width: 100%'
      border
      header-cell-class-name='myth'
      cell-class-name='mytd'
      v-loading="loading"
      size='small'
    >
      <el-table-column
        type="index"
        width="100"
        :index='indexMethod'
      />
      <el-table-column
        prop='create_user_name'
        label='操作人'
      />
      <el-table-column
        prop='ip'
        label='IP'
      />
      <el-table-column
        label='cmd'
      >
        <template slot-scope='scope'>
          <el-tooltip :content="scope.row.cmd_desc" placement="bottom">
            <span style="cursor: pointer" >{{scope.row.cmd}}</span> 
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        prop='rst_msg'
        label='执行结果'
      />
      <el-table-column
        prop='rst_data'
        label='结果数据'
        min-width="240"
      />
      <el-table-column
        prop='create_dt'
        label='时间'
        width='180'
      />
    </el-table>
    <!-- 分页器 -->
    <div class="flex-row-end" style="margin-top: 16px;">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        :page-size="pageSize"
        v-if="total > pageSize"
        @current-change="onPageChange"
        :current-page.sync='currentPage'
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
  import { mapState, mapActions } from 'vuex'
  import { post, get } from '@/utils/http'
  import { format } from '@/utils/util'

  export default {
    data() {
      return {
        operationlog: [],
        total: 0,
        pageStart: 0,
        pageEnd: 0,
        currentPage: 1,
        pageSize: 50,
        form: {},
        loading: false,
        f_daterange: [],
        create_user_id: 'all',
        userlist: []
      }
    },
    computed: {
      ...mapState(['user_id', 'unit_id', 'user_is_pta'])
    },
    mounted() {
      const end = new Date()
      const start = new Date()
      this.f_daterange = [start, end]
      this.getUsers()
      this.getOperationlog()
    },
    methods: {
      // 获取用户
      async getUsers() {
        try {
          const res = await post('/index/Auth/getUsers', {
            unit_id: this.unit_id
          })
          if (res && res.rst == 0) {
            this.userlist = res.data
          }
        } catch(err) {
        }
      },
      // 获取盒子列表
      async getOperationlog() {
        this.loading = true
        const data = {
          page_ix: this.currentPage,
          page_size: this.pageSize,
          date_from: this.f_daterange[0].toLocaleDateString().split('/').join('-'),
          date_to: this.f_daterange[1].toLocaleDateString().split('/').join('-')
        }
        if (this.create_user_id != 'all') {
          data.create_user_id = this.create_user_id
        }
        try {
          const res = await post('/help/server/queryLog', data)
          this.loading = false
          if (res && res.rst == 0) {
            this.operationlog = res.data.data
            this.total = res.data.total
            this.pageStart = (res.data.current_page - 1) * this.pageSize
            this.pageEnd = this.pageStart + this.pageSize
          }
        } catch(err) {
          this.loading = false
        }
      },
      onPageChange(page) {
        this.currentPage = page
        this.getOperationlog()
      },
      indexMethod(index) {
        return index + this.pageStart + 1;
      },
    },
    name: 'operationlog'
  }
</script>
<style lang='less' scoped>
  .operationlog {
    
  }
</style>
